module.exports = __webpack_public_path__ + "static/media/Chevevxdange-01.1b38bf6e.svg";